import { create } from "zustand";

type Announcement = {
  id: string;
  title: string;
  description: string;
  files: string[];
  createdAt: string;
} | null;

interface HookProps {
  open: boolean;
  announcement: Announcement;
  onOpenChange: (open: boolean) => void;
  setAnnouncement: (announcement: Announcement) => void;
}

export const useViewModal = create<HookProps>()((set) => ({
  open: false,
  announcement: null,
  onOpenChange: (open) =>
    set(() => ({
      open,
    })),
  setAnnouncement: (announcement) =>
    set(() => ({
      announcement,
    })),
}));
